import Raven from 'raven-js';
import identity from 'transmute/identity';
import { evaluateProposedRulesRpc } from '../../../__generated__/chirp/com/hubspot/property/validation/rpc/PropertyValidationRpc';
import { InMemoryCache } from '../InMemoryCache';
const DEFAULT_VALID = {
  isValid: true,
  error: null,
  message: null
};
const fetchValidateUrlChirp = (url, rpcClient) => {
  return rpcClient.call(evaluateProposedRulesRpc, {
    request: {
      proposedRules: [{
        ruleType: 'URL',
        ruleArguments: []
      }],
      proposedValue: url
    }
  }).then(response => {
    const result = response.validationResults[0];
    if (!result) {
      return DEFAULT_VALID;
    }
    return {
      isValid: result.isValid,
      error: result.error && result.error !== 'NO_ERROR' ? String(result.error) : null,
      message: result.message || null
    };
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        url
      }
    });
  });
};
export const makeUrlValidationCache = () => new InMemoryCache('UrlValidationCache', identity, ({
  rpcClient
}) => url => fetchValidateUrlChirp(url, rpcClient));